import { useParams } from 'react-router-dom';
import { useIsOnline } from '../../../hooks';
import { useGetOfflineFirstSectionsQuery, useGetSectionsQuery } from '../../../services/api/vehicle-sections';
import { useCallback, useEffect, useState } from 'react';
import { db, SectionRow } from '../../../db';
import { Section } from '../../../services/api/vehicle-sections/types';
import { setIn } from 'final-form';
import { generateRandomId } from '../../../utils/crypto';
import { useGetVehicleByIdQuery } from 'services/api/upload-vehicle';

async function buildTree(
  vehicleId: number,
  parentSection: SectionRow | null,
  parentKey: string | null,
  result: Record<string, Section>
) {
  const sections = await db.sections
    .where('[formId+parentId]')
    .equals([vehicleId, parentSection?.id ?? 0])
    .sortBy('order');

  for (const section of sections) {
    const key = (() => {
      if (!parentSection || !parentKey) return section.name;
      return `${parentKey}.subsections.${section.name}`;
    })();
    console.log(key, 'key');
    const copy = { ...section } as Partial<SectionRow & Section>;
    delete copy.formId;
    if (section.parentId === 0) {
      copy.parentId = null;
    }

    const images = await db.images
      .where('sectionId')
      .equals(section.id)
      .toArray();

    copy.images = images.map<any>(img => ({
      id: img.serverId!,
      vehicle_section_id: img.sectionId,
      file: img.blob ? new File([img.blob], generateRandomId()) : undefined,
      url: img.url!,
      url_thumb: img.url_thumb,
      notes: img.notes || undefined,
      o: img.o
    }));

    const checkboxes = await db.checkboxes
      .where('sectionId')
      .equals(section.id)
      .toArray();

    copy.checkboxes = checkboxes as any[];

    const updatedResult = setIn(result, key, copy) as Record<string, Section>;
    result = await buildTree(vehicleId, section, key, updatedResult);
  }

  return result;
}

export const useInitialFormValues = () => {
  const { id: vehicleId } = useParams<{ id: string }>();
  const { data: vehicle } = useGetVehicleByIdQuery(Number(vehicleId), { skip: !vehicleId });
  const { data } = useGetOfflineFirstSectionsQuery(Number(vehicleId), { skip: !vehicleId });

  const sections = data?.data;

  const [initialValues, setInitialValues] = useState<any>({});

  const getInitialValues = useCallback(async () => {
    const numericId = Number(vehicleId);
    if (!numericId) return;

    if (!sections) return;
    setInitialValues({ ...sections, inspector_notes: vehicle?.inspector_notes || {}, vehicleId: numericId });
  }, [sections, vehicleId, vehicle?.inspector_notes]);

  useEffect(() => {
    getInitialValues();
  }, [getInitialValues]);

  return initialValues;
};
